export default {
    STORE_DESIRED_OCCUPATION(state, data) {
        state.desiredOccupations = data;
    },
};
